
import './styles/quasar.sass'
import iconSet from 'quasar/icon-set/material-icons-sharp.js'
//import iconSet2 from '@quasar/extras/material-icons-sharp/index.mjs'
import '@quasar/extras/material-icons-sharp/material-icons-sharp.css'
import Notify from 'quasar/src/plugins/Notify.js';import Loading from 'quasar/src/plugins/Loading.js';

// To be used on app.use(Quasar, { ... })
export default {
  config: {
    notify: { /* look at QuasarConfOptions from the API card */ },
    loading: {}
  },
  plugins: {
    Notify,
    Loading
  },
  iconSet: iconSet,
}